﻿import { getInitDataRaw } from './telegram';

import { formatImageUrl } from './imageUrl';
import { haptic, tgWebApp } from './telegram';

const BASE = import.meta.env.VITE_BACKEND_URL ?? '';

export async function downloadTemplate(): Promise<void> {
  const initData = getInitDataRaw();
  const res = await fetch(`${BASE}/import/template`, {
    headers: {
      'X-Telegram-Init-Data': initData,
    },
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(txt || `HTTP ${res.status}`);
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = 'fitbot-import-template.xlsx';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function downloadByUrl(url: string, filename: string): Promise<void> {
  const imageUrl = formatImageUrl(url);
  if (!imageUrl) {
    haptic.error();
    throw new Error('Image URL is empty');
  }

  const tg = tgWebApp() as ReturnType<typeof tgWebApp> & {
    downloadFile?: (params: { url: string; file_name: string }, callback?: (accepted: boolean) => void) => void;
    openLink?: (url: string) => void;
  };
  if (tg?.downloadFile) {
    tg.downloadFile({ url: imageUrl, file_name: filename }, (accepted) => {
      if (accepted) haptic.success();
      else haptic.warning();
    });
    return;
  }
  if (tg?.openLink) {
    tg.openLink(imageUrl);
    haptic.success();
    return;
  }

  try {
    const res = await fetch(imageUrl);
    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error(txt || `HTTP ${res.status}`);
    }
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    try {
      const a = document.createElement('a');
      a.href = objUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      haptic.success();
    } finally {
      URL.revokeObjectURL(objUrl);
    }
  } catch (error) {
    try {
      window.open(imageUrl, '_blank', 'noopener,noreferrer');
      haptic.warning();
    } catch {
      haptic.error();
      throw error;
    }
  }
}
